/* ==========================================================================
   CannotShy — shared section behaviour
   Two jobs: reveal-on-scroll, and keeping the hero video off the critical
   path. Everything degrades to "content is visible" if this never runs.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESKTOP = 750;

  /* --- Reveal on scroll ------------------------------------------------ */

  function initReveal() {
    var targets = document.querySelectorAll('.cs-reveal:not(.cs-reveal--on)');
    if (!targets.length) return;

    // No observer, or the visitor asked for less motion: show everything now.
    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      targets.forEach(function (el) {
        el.classList.add('cs-reveal--on');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('cs-reveal--on');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Hero video ------------------------------------------------------ */

  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }

  function shouldPlay(video) {
    if (reduceMotion.matches) return false;
    if (saveData()) return false;
    if (video.hasAttribute('data-cs-desktop-only') && window.innerWidth < DESKTOP) return false;
    return true;
  }

  function loadVideo(video) {
    if (video.dataset.csLoaded) return;
    video.dataset.csLoaded = 'true';

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    sources.forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.addEventListener(
      'playing',
      function () {
        video.classList.add('is-playing');
      },
      { once: true }
    );

    video.load();

    // Autoplay can still be refused (low power mode, for one). The poster
    // stays put in that case, which is a perfectly good hero.
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        /* poster remains visible */
      });
    }
  }

  function initHeroVideo() {
    var heroes = document.querySelectorAll('[data-cs-hero]');
    if (!heroes.length) return;

    heroes.forEach(function (hero) {
      var video = hero.querySelector('.cs-hero__video');
      if (!video || !shouldPlay(video)) return;

      if (!('IntersectionObserver' in window)) {
        loadVideo(video);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadVideo(video);
            observer.disconnect();
          });
        },
        { rootMargin: '200px' }
      );

      observer.observe(hero);
    });
  }

  /* --- Boot ------------------------------------------------------------ */

  function init() {
    initReveal();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor tears sections down and rebuilds them.
  document.addEventListener('shopify:section:load', init);
})();
